import styles from './PasswordStrengthMeter.module.css';

/**
 * Password strength score (0–4), matching the design's rubric: +1 for each of
 * length ≥ 8, an uppercase letter, a digit, a symbol, and length ≥ 14 (capped 4).
 */
export function scorePassword(v: string): number {
  let n = 0;
  if (v.length >= 8) n++;
  if (/[A-Z]/.test(v)) n++;
  if (/\d/.test(v)) n++;
  if (/[^A-Za-z0-9]/.test(v)) n++;
  if (v.length >= 14) n++;
  return Math.min(n, 4);
}

/** Strength bar + label shown under the password field once the user types. */
export function PasswordStrengthMeter({ value }: { value: string }) {
  const pw = value || '';
  if (!pw) return null;
  const score = scorePassword(pw);
  const level = score >= 4 ? 'strong' : score === 3 ? 'fair' : 'weak';
  const label = score >= 4 ? 'Strong' : score === 3 ? 'Fair' : 'Weak';
  return (
    <div className={styles.meter}>
      <div className={styles.track}>
        <div
          className={`${styles.fill} ${styles[level]}`}
          style={{ width: `${(score / 4) * 100}%` }}
        />
      </div>
      <span className={`${styles.label} ${styles[level]}`}>{label}</span>
    </div>
  );
}

export default PasswordStrengthMeter;
